export enum ZoomMode {
    Pan,
    Zoom,
    Selection
}